<template>
  <div>
    <div
      class="ghl-form-survey-text-style-editor flex flex-wrap items-center gap-1.5 px-2 py-1.5"
      :style="{ borderBottom: '1px solid #E5E7EB' }"
    >
      <RTEControlHistory type="undo" :editor="editor" />
      <RTEControlHistory type="redo" :editor="editor" />

      <UIDivider :vertical="true" />

      <div class="overflow-menu-icon">
        <RTEControlColorPicker :editor="editor" tooltip-label="Text color" />
      </div>
      <RTEControlLineHeight :editor="editor" :fallback-line-height="'1'" />

      <RTEControlEmbedLink :editor="editor" :modal-container="modalContainer" />
      <RTEControlEmbedImage
        :editor="editor"
        external-embed-text="Upload"
        :external-embedded-image="externalEmbeddedImage"
        :modal-container="modalContainer"
        @trigger-external-embed="triggerExternalEmbed"
      />
      <UIDivider v-if="!mobileInline" :vertical="true" />

      <RTEControlCustomVariablePicker
        :editor="editor"
        :is-submit-message="isSubmitMessage === true"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  IMediaCenterSelection,
  MediaCenterAllowedExtensions,
  MediaCenterSubCategory,
} from "@/helpers/mediaCenter.type";
import { triggerMediaCenterOpen } from "@/helpers/mediaCenterUtil";
import { useAppStore } from "@/store/app";
import {
  RTEControlColorPicker,
  RTEControlEmbedImage,
  RTEControlEmbedLink,
  RTEControlHistory,
  RTEControlLineHeight,
} from "@gohighlevel/ghl-text-editor";
import { UIDivider } from "@gohighlevel/ghl-ui";
import { Editor } from "@tiptap/vue-3";
import { nextTick, ref } from "vue";
import RTEControlCustomVariablePicker from "./RTEControlCustomVariablePicker.vue";

type Props = {
  editor: Editor;
  mobileInline?: boolean;
  isSubmitMessage?: boolean;
  // When the editor is used inside a modal, provide a container
  // element or selector so embed modals teleport inside it.
  modalContainer?: string | HTMLElement | null;
  mediaCenterSubCategory: MediaCenterSubCategory;
};
const props = defineProps<Props>();

const store = useAppStore();
const externalEmbeddedImage = ref<string | null>(null);

const handleMediaCenterAttachment = (data: IMediaCenterSelection) => {
  if (data?.url) {
    if (externalEmbeddedImage.value === data.url) {
      externalEmbeddedImage.value = null;
      void nextTick(() => {
        externalEmbeddedImage.value = data.url;
      });
      return;
    }
    externalEmbeddedImage.value = data.url;
  }
};

const triggerExternalEmbed = () => {
  triggerMediaCenterOpen({
    appHandshake: store.appHandshake,
    settings: {
      allowedExtensions: [MediaCenterAllowedExtensions.IMAGE],
      allowMultipleFileInsertion: false,
      subCategory: props.mediaCenterSubCategory,
    },
    onSelect: handleMediaCenterAttachment,
  });
};
</script>

<style scoped>
.ghl-form-survey-text-style-editor {
  user-select: none;
  -webkit-user-select: none;
}

.ghl-form-survey-text-style-editor :deep(.n-base-selection .n-base-selection-label),
.ghl-form-survey-text-style-editor
  :deep(.n-button--default-type:not(.icon-only):not(.hl-active-btn)) {
  background-color: transparent !important;
}
</style>
